exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.confirm_btn_class {\n    font-size: 14px;\n}\n.cancel_btn_class {\n    font-size: 14px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-615b2308!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/emapm-upload-imgs.vue
// module id = 173
// module chunks = 0